import { cancel, delay, fork, put, take } from 'redux-saga/effects';

const REQUEST_TYPE = 'SUPPLIER_MATCHES/requestMatchingSupplierCountLoading';
const RESET_DELAY_MS = 2000;

function* dispatchWithDelay(payload) {
  yield delay(RESET_DELAY_MS);
  yield put({
    type: 'SUPPLIER_MATCHES/setMatchingSupplierCountLoading',
    payload,
  });
}

export default function* matchingSupplierCountLoadingWatcher() {
  let pendingTask = null;

  while (true) {
    const action = yield take(REQUEST_TYPE);

    if (pendingTask) {
      yield cancel(pendingTask);
      pendingTask = null;
    }

    const { payload } = action;
    if (payload?.isLoading) {
      yield put({
        type: 'SUPPLIER_MATCHES/setMatchingSupplierCountLoading',
        payload,
      });
    } else {
      pendingTask = yield fork(dispatchWithDelay, payload);
    }
  }
}
